import { Link } from "react-router-dom";
import { Mail, ChevronDown } from "lucide-react";
import { Button } from "@/components/ui/button";

const MagazineHero = () => {
  return (
    <div className="relative overflow-hidden min-h-[70vh] flex items-center">
      {/* Background layers */}
      <div className="absolute inset-0 bg-gradient-to-br from-background via-deep-water to-background" />
      <div
        className="absolute inset-0 bg-cover bg-center opacity-20"
        style={{ backgroundImage: "url('/lovable-uploads/28cf831b-cd8f-41ce-af11-cf126f231ed1.png')" }}
      />
      {/* Mist overlay effect */}
      <div className="absolute inset-0 bg-gradient-to-t from-background via-transparent to-background/80" />

      <div className="relative container mx-auto px-4 py-24 text-center">
        <p className="text-accent text-sm font-semibold tracking-[0.3em] uppercase mb-6">
          Documenting the Unknown
        </p>
        <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold mb-6 text-foreground leading-[1.1] tracking-tight">
          The Loch Ness
          <br />
          <span className="italic text-accent">Mystery</span>
        </h1>
        <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto mb-10 leading-relaxed">
          Sightings, research, and the enduring characters behind Scotland's most famous enigma — explored in depth.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link to="/sightings">
            <Button
              size="lg"
              className="bg-accent text-accent-foreground hover:bg-accent/90 font-semibold px-8"
            >
              Explore Sightings
            </Button>
          </Link>
          <a href="mailto:simondawes7@gmail.com">
            <Button
              size="lg"
              variant="outline"
              className="border-border text-foreground hover:bg-secondary inline-flex items-center gap-2"
            >
              <Mail className="w-4 h-4" />
              Report a Sighting
            </Button>
          </a>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 animate-bounce text-muted-foreground">
        <ChevronDown className="w-6 h-6" />
      </div>
    </div>
  );
};

export default MagazineHero;
